<template>
    <div class="header-container" :class="{ 'is-admin-mode': isAdminRoute }" v-if="$route.meta.isHeader">
        <div class="header">
            <!-- 版心区域两端对齐：后台模式下自适应撑满，前台模式保持 1240px 居中 -->
            <div class="wrapper flex-left-rigth" :class="{ 'admin-wrapper': isAdminRoute }">

                <!-- 左侧内容 -->
                <div class="flex-left flex-middle-x">
                    <a href="/">
                        <div class="home flex-middle-x">
                            <img src="./image/home-icon.png" alt="">
                            首页
                        </div>
                    </a>
                    <div class="shop flex-middle-x cursor-pointer" @click="LmSelectStoreRef.openDialog();">
                        <img src="./image/location-icon.png" alt="">
                        <div class="flex-middle-x">
                            {{ userStore.userInfo?.analysis?.storename }} <img src="../assets/images/pull-down.png" alt="">
                        </div>
                    </div>
                </div>

                <!-- 右侧内容 -->
                <div class="flex-rigth flex-middle-x">
                    <!-- 即时零售入口（原"管理后台"） -->
                    <router-link v-if="showAdminEntry" to="/pcadmin">
                        <div
                            class="cart flex-middle-x cursor-pointer nav-tab-item"
                            :class="{ 'nav-tab-active': isAdminRoute }"
                        >
                            <svg class="retail-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z" />
                                <path d="m3.3 7 8.7 5 8.7-5" />
                                <path d="M12 22V12" />
                            </svg>
                            即时零售
                        </div>
                    </router-link>

                    <a href="/cart" target="_blank">
                        <div class="cart flex-middle-x">
                            <img src="./image/cart-icon.png" alt="" class="cart-icon">
                            购物车{{ cartStore?.cartNum }}
                        </div>
                    </a>

                    <el-dropdown @command="handleCommand" >
                        <div class="order el-dropdown-link">
                            我的订单 <img src="../assets/images/pull-down.png" alt="">
                        </div>
                        <template #dropdown>
                            <el-dropdown-menu>
                                <el-dropdown-item command="ALL_ORDERS">
                                    全部订单
                                </el-dropdown-item>
                                <el-dropdown-item command="LOCAL_DELIVERY">
                                    本地发货
                                </el-dropdown-item>
                                <el-dropdown-item command="LOCAL_RETURNS">
                                    本地退货
                                </el-dropdown-item>
                                <el-dropdown-item command="DIRECT_ORDER">
                                    直发订单
                                </el-dropdown-item>
                                <el-dropdown-item command="DIRECT_RETURN_ORDER">
                                    直发退货订单
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </template>
                    </el-dropdown>

                    <div class="app-lm" @mouseover="hover = true" @mouseleave="hover = false">
                        手机联盟 <img src="../assets/images/pull-down.png" alt="">
                        <div class="hover-black" v-show="hover">
                            <img src="@/assets/images/qrcode.png" alt="">
                            <div class="app-text">
                                手机APP下载
                            </div>
                        </div>
                    </div>

                    <!-- 用户信息区域 -->
                    <el-dropdown class="user-dropdown-area" trigger="hover" @command="handleUserCommand">
                        <div class="user-info-wrapper flex-middle-x">
                            <div class="user-avatar">
                                <img
                                    v-if="userAvatarUrl"
                                    :src="userAvatarUrl"
                                    class="avatar-img"
                                    alt="avatar"
                                >
                                <span v-else class="avatar-letter">{{ avatarInitial }}</span>
                            </div>
                            <span class="user-name-text">{{ displayUserName }}</span>
                            <img src="../assets/images/pull-down.png" alt="" class="user-arrow">
                        </div>
                        <template #dropdown>
                            <el-dropdown-menu>
                                <el-dropdown-item command="profile">
                                    <el-icon>
                                        <component :is="Icons.User" />
                                    </el-icon>
                                    <span>个人中心</span>
                                </el-dropdown-item>
                                <el-dropdown-item command="logout" divided>
                                    <el-icon>
                                        <component :is="Icons.SwitchButton" />
                                    </el-icon>
                                    <span class="logout-text">退出登录</span>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </template>
                    </el-dropdown>

                </div>
            </div>
        </div>
    </div>
    <lm-select-store ref="LmSelectStoreRef"/>
</template>

<script lang="ts" setup>
import { useUserStore } from "@/stores/modules/user";
import { useCartStore } from "@/stores/modules/cart";

import LmSelectStore from "@/components/lm-select-store/index.vue";

import * as Icons from "@element-plus/icons-vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { useRoute, useRouter } from "vue-router";

const route = useRoute();
const router = useRouter();
const userStore = useUserStore();
const cartStore = useCartStore();
const hover = ref(false);

const showAdminEntry = computed(() => {
    return Boolean(userStore.userInfo && userStore.userInfo.type !== 10);
});

// 是否当前在后台路由
const isAdminRoute = computed(() => {
    return route.path.startsWith("/pcadmin");
});

// 用户显示名称
const displayUserName = computed(() => {
    return userStore.userInfo?.nickname || userStore.userInfo?.username || "个人中心";
});

// 用户头像 URL
const userAvatarUrl = computed(() => {
    return userStore.userInfo?.avatar_url || userStore.userInfo?.avatar || "";
});

// 用户名称首字符（无头像时降级展示）
const avatarInitial = computed(() => {
    const name = userStore.userInfo?.nickname || userStore.userInfo?.username || userStore.userInfo?.analysis?.userName;
    return name ? name.charAt(0).toUpperCase() : "管";
});

const LmSelectStoreRef = ref(null) as any;
onMounted(() => {
    cartStore.getCartCount();
});

const handleCommand = (type: string) => {
    window.open(`/order?type=${type}`, "_blank");
};

// 用户菜单操作
const handleUserCommand = async (command: string) => {
    if (command === "profile") {
        window.open("/order", "_blank");
    } else if (command === "logout") {
        try {
            await ElMessageBox.confirm("确定要退出登录吗？", "退出提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            });

            // 清理用户数据
            userStore.clearUserInfo();
            localStorage.removeItem("pcToken");
            localStorage.removeItem("storeId");

            // 如果在后台，还需清理后台状态
            if (isAdminRoute.value) {
                const { useAdminTagsViewStore } = await import("@/stores/modules/admin/tagsView");
                const { useAdminPermissionStore } = await import("@/stores/modules/admin/permission");
                const tagsViewStore = useAdminTagsViewStore();
                const permissionStore = useAdminPermissionStore();
                await tagsViewStore.delAllViews();
                permissionStore.resetRoutes();
            }

            ElMessage.success("已成功退出登录");
            router.push("/login");
        } catch {
            // 取消退出
        }
    }
};

</script>


<style lang="scss" scoped>
.header-container {
    .header {
        height: 44px;
        background: linear-gradient(90deg, #FFE665 0%, #FFD500 100%), #FFFFFF;
        display: flex;
        align-items: center;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        line-height: 21px;

        img {
            width: 18px;
            height: 18px;
            display: block;
            margin-right: 4px;
        }
    }
}

:deep(.el-dropdown-menu__item){
   justify-content: center;
}

.admin-wrapper {
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 !important;
    padding: 0 20px !important;
    box-sizing: border-box;

    .flex-left {
        .home {
            margin-left: 0 !important;
        }
    }
}

.wrapper {
    .flex-left {
        .home {
            margin-left: 82px;
            margin-right: 16px;

            a {
                margin-right: 16px;
            }
        }
        .shop{
            .flex-middle-x{
                img{
                    width: 12px;
                    height: 12px;
                    display: block;
                    margin-left: 4px;
                }
            }
        }
    }

    .flex-rigth {

        .cart,
        .order,
        .lm,
        .app-lm {
            margin-right: 16px;
            display: flex;
            color: #333333;
            align-items: center;
            cursor: pointer;

            img {
                width: 12px;
                height: 12px;
                display: block;
                margin-left: 4px;
            }

            .cart-icon {
                width: 18px;
                height: 18px;
                margin-right: 4px;
            }
            .cart-icon-setting {
                font-size: 18px;
            }
        }

        // 即时零售 tab 样式
        .nav-tab-item {
            margin-right: 16px;
            transition: all 0.2s;
            display: flex;
            align-items: center;
            justify-content: center;

            .retail-nav-icon {
                width: 16px;
                height: 16px;
                margin-right: 4px;
                display: block;
                flex-shrink: 0;
            }

            &.nav-tab-active {
                padding: 0 14px;
                height: 30px;
                line-height: 30px;
                border-radius: 4px;
                background-color: #ffffff;
                font-weight: 600;
                color: #1a1a1a;
                box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
            }
        }

        .app-lm {
            position: relative;
        }

        .hover-black {
            position: absolute;
            top: 30px;
            left: -44px;
            right: 0;
            width: 148px;
            background-color: #fff;
            margin: auto;
            box-shadow: 0px 2px 4px 1px rgba(0, 0, 0, 0.08);
            border-radius: 8px;

            img {
                width: 126px;
                height: 126px;
                display: block;
                margin: 15px auto 0 auto;
            }

            .app-text {
                font-weight: 400;
                font-size: 14px;
                color: #B3B3B3;
                line-height: 21px;
                text-align: center;
                margin-top: 10px;
                padding-bottom: 10px;
            }
        }

        // 用户信息区域
        .user-dropdown-area {
            margin-left: 4px;

            .user-info-wrapper {
                display: flex;
                align-items: center;
                cursor: pointer;
                gap: 6px;

                .user-avatar {
                    width: 24px;
                    height: 24px;
                    border-radius: 50%;
                    background: #4e5969;
                    color: #ffffff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-shrink: 0;
                    overflow: hidden;
                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);

                    .avatar-img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        display: block;
                    }

                    .avatar-letter {
                        font-size: 12px;
                        font-weight: 700;
                        color: #ffffff;
                        line-height: 1;
                        user-select: none;
                    }
                }

                .user-name-text {
                    font-size: 14px;
                    color: #333333;
                    max-width: 80px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                .user-arrow {
                    width: 12px !important;
                    height: 12px !important;
                    margin-left: 2px;
                }
            }
        }
    }
}

.logout-text {
    color: #f56c6c;
}
</style>